import React from 'react';
import {Link} from 'react-router-dom';
import Lightbox from "yet-another-react-lightbox";
import MetaTags from "../components/MetaTags";

const Krestik: React.FC = () => {
    const [open, setOpen] = React.useState(false);
    const [image, setImage] = React.useState<number>(0);

    const images = [
        {src: "/image/Schema/kP7060032.jpg"},
        {src: "/image/Schema/kP7060036.jpg"},
    ];

    const viewImage = (event: any) => {
        setOpen(true)
        setImage(Number(event.target.id.replace(/\D/g, '')))
    }

    MetaTags(
        "Плетение крестиком",
        "Схема плетения цепочки простым и широким крестиком. Из цепочки расширенным крестиком можно создать множество узоров. Примеры браслетов на основе крестика."
    )

    return <>
        <h2>Плетение крестиком</h2>

        <p>Эта цепочка плетется на двух нитках, но она очень простая.</p>

        <p>Сначала нужно сложить леску пополам и на ее середину набрать четыре бисеринки (рис.А). В одну из крайних бисеринок проденем второй конец лески и затянем&nbsp;— получится колечко (рис.Б). Дальше нанизываем на правую нить две бисеринки, а на левую&nbsp;— одну. Затем протаскиваем левую леску через вторую бисеринку на правой леске так, чтобы она шла навстречу леске, которая уже торчит из бисеринки и затягиваем (рис.В, Г).</p>

        <div className="row">
            <div className="col-sm-4">
                <img src="/image/Schema/mP7060032.jpg" className="picture1 xs-centered img-rounded" width="150"
                     height="196" alt="Браслеты на основе крестика"
                     id="image-0"
                     onClick={viewImage}
                />
            </div>
            <div className="col-sm-8">
                <img src="/image/Schema/krestik.jpg" className="picture1 xs-centered right schema img-responsive" width="394" height="196" alt="Схема плетения крестика"/>
            </div>
        </div>
        <h2 className="topic1">Расширенный крестик</h2>

        <p>Эту цепочку можно сплести любой ширины и создать множество разнообразных узоров.</p>

        <p>Если вы хотите сделать цепочку, например, шириной в три крестика. Сначала сплетите два обычных крестика, а для третьего&nbsp;— наберите на левую леску три бисеринки и проденьте правую леску в последнюю, и затяните колечко (рис.А). Затем наберите на правую леску две бисеринки, а на левую&nbsp;— одну (рис.Б). Проденьте правую леску в бисеринку на левой и затяните колечко (рис.В). Потом проденьте 1ю леску в бисеринку, отмеченную красным на рисунке, и наберите по одной бисеринке на каждую леску. Проденьте 1ю леску через бисеринку на 2й и затяните колечко (рис.Г). Теперь продеваем 2ю леску в желтую бисеринку на рисунке и надеваем на нее две бисеринки, в последнюю из которых пропускаем леску 1, и снова затягиваем колечко (рис.Д). И так далее повторяем все операции.</p>

        <img src="/image/Schema/CHkrestik.jpg" className="schema pic-wide col-centered img-responsive" width="550" height="205" alt="Схема плетения расширенного крестика"/>
        <img src="/image/Schema/mP7060036.jpg" className="schema img-rounded col-centered img-responsive" width="550"
             height="320" alt="Браслеты на основе крестика"
             id="image-1"
             onClick={viewImage}
        />

        <Lightbox
            open={open}
            close={() => setOpen(false)}
            slides={[
                images[image], // Выбранный элемент
                ...images.slice(0, image), // Элементы до выбранного
                ...images.slice(image + 1) // Элементы после выбранного
            ]}
        />
    </>;
};

export default Krestik;

